import { PublishScheduleNotificationSummaryProps } from '../types';
import { useTranslation } from 'react-i18next';
import { AlertDialogDescription } from '@components/ui/alert';
import { SvgConsumer } from '@components/icons/svgConsumer';

export const PublishScheduleConfirmationNotificationSummary = ({
  fieldUserAsCrewIds,
  crewsWithoutPhoneIds,
  crewsWithPhoneIds,
  uniqueForemenIds,
  title,
}: PublishScheduleNotificationSummaryProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'publisher.notification' });

  const totalFieldUsers = Array.from(
    new Set([...(fieldUserAsCrewIds || []), ...(uniqueForemenIds || [])]),
  ).length;

  return (
    <>
      <AlertDialogDescription className="font-semibold text-natural-400">
        {title || t('title')}
      </AlertDialogDescription>
      <div className="flex flex-col gap-1">
        <div className="flex items-center pl-2.5">
          <SvgConsumer
            id="notifications"
            className="text-blue-600"
            style={{ width: '19px', height: '19px' }}
          />
          <span className="text-neutral-500 pl-1.5">
            {t('fieldUser', {
              count: totalFieldUsers,
            })}
          </span>
        </div>
        <div className="flex items-center pl-3">
          <SvgConsumer
            id="issue"
            className="text-blue-600"
            style={{ width: '15px', height: '15px' }}
          />
          <span className="text-neutral-500 pl-2">
            {t('crewWithPhone', { count: crewsWithPhoneIds.length })}
          </span>
        </div>
        <div className="flex items-center pl-3">
          <SvgConsumer
            id="circleError"
            className="text-danger-600"
            style={{ width: '15px', height: '15px' }}
          />
          <span className="text-neutral-500 pl-2">
            {t('crewWithoutPhone', { count: crewsWithoutPhoneIds.length })}
          </span>
        </div>
      </div>
    </>
  );
};
